module.exports = __webpack_public_path__ + "img/dash-card-sales.4a44ed7c.svg";